import { useMemo } from "react";

import { Background } from "./Background";
import { Person } from "./Person";
import { TreeSmall } from "./TreeSmall";
import { TreeMedium } from "./TreeMedium";
import { TreeLarge } from "./TreeLarge";

export interface MultiStemTreeDiagramProps {
  label: string;
  treeDiameter: number;
  treeDistance?: number;
}

export function MultiStemTreeDiagram({
  label,
  treeDiameter,
  treeDistance,
}: MultiStemTreeDiagramProps) {
  const lineStylesLeft = useMemo(() => {
    if (treeDiameter <= 0.1) {
      return { width: `${treeDiameter * 60}px`, marginLeft: "-36px" };
    }
    if (treeDiameter <= 0.2) {
      return { width: `${treeDiameter * 40}px`, marginLeft: "-42px" };
    }
    if (treeDiameter <= 0.3) {
      return { width: `${treeDiameter * 35}px`, marginLeft: "-48px" };
    }
    if (treeDiameter <= 0.4) {
      return { width: `${treeDiameter * 28}px`, marginLeft: "-50px" };
    }
    if (treeDiameter <= 0.5) {
      return { width: `${treeDiameter * 28}px`, marginLeft: "-29px" };
    }
    if (treeDiameter <= 0.6) {
      return { width: `${treeDiameter * 25}px`, marginLeft: "-31px" };
    }
    if (treeDiameter <= 0.7) {
      return { width: `${treeDiameter * 22}px`, marginLeft: "-30px" };
    }
    if (treeDiameter <= 0.8) {
      return { width: `${treeDiameter * 20}px`, marginLeft: "-31px" };
    }
    if (treeDiameter <= 0.9) {
      return { width: `${treeDiameter * 20}px`, marginLeft: "-29px" };
    }
    if (treeDiameter <= 1.0) {
      return { width: `22px`, marginLeft: "-87px" };
    }
    if (treeDiameter <= 1.1) {
      return { width: `22px`, marginLeft: "-87px" };
    }
    if (treeDiameter <= 1.2) {
      return { width: `22px`, marginLeft: "-87px" };
    }
    if (treeDiameter <= 1.3) {
      return { width: `22px`, marginLeft: "-87px" };
    }
    if (treeDiameter <= 1.4) {
      return { width: `22px`, marginLeft: "-87px" };
    }
    if (treeDiameter <= 1.5) {
      return { width: `23px`, marginLeft: "-87px" };
    }
  }, [treeDiameter]);

  const lineStylesMiddle = useMemo(() => {
    if (treeDiameter <= 0.1) {
      return { width: `${treeDiameter * 70}px`, marginLeft: "-6px" };
    }
    if (treeDiameter <= 0.2) {
      return { width: `${treeDiameter * 50}px`, marginLeft: "-7px" };
    }
    if (treeDiameter <= 0.3) {
      return { width: `${treeDiameter * 35}px`, marginLeft: "-9px" };
    }
    if (treeDiameter <= 0.4) {
      return { width: `${treeDiameter * 28}px`, marginLeft: "-9px" };
    }
    if (treeDiameter <= 0.5) {
      return { width: `${treeDiameter * 32}px`, marginLeft: "12px" };
    }
    if (treeDiameter <= 0.6) {
      return { width: `${treeDiameter * 28}px`, marginLeft: "14px" };
    }
    if (treeDiameter <= 0.7) {
      return { width: `${treeDiameter * 25}px`, marginLeft: "18px" };
    }
    if (treeDiameter <= 0.8) {
      return { width: `${treeDiameter * 24}px`, marginLeft: "20px" };
    }
    if (treeDiameter <= 0.9) {
      return { width: `${treeDiameter * 23}px`, marginLeft: "23px" };
    }
    if (treeDiameter <= 1.0) {
      return { width: `${treeDiameter * 19}px`, marginLeft: "-27px" };
    }
    if (treeDiameter <= 1.1) {
      return { width: `19px`, marginLeft: "-27px" };
    }
    if (treeDiameter <= 1.2) {
      return { width: `19px`, marginLeft: "-27px" };
    }
    if (treeDiameter <= 1.3) {
      return { width: `19px`, marginLeft: "-27px" };
    }
    if (treeDiameter <= 1.4) {
      return { width: `19px`, marginLeft: "-27px" };
    }
    if (treeDiameter <= 1.5) {
      return { width: `20px`, marginLeft: "-27px" };
    }
  }, [treeDiameter]);

  const lineStylesRight = useMemo(() => {
    if (treeDiameter <= 0.1) {
      return { width: `${treeDiameter * 75}px`, marginLeft: "16px" };
    }
    if (treeDiameter <= 0.2) {
      return { width: `${treeDiameter * 42}px`, marginLeft: "18px" };
    }
    if (treeDiameter <= 0.3) {
      return { width: `${treeDiameter * 28}px`, marginLeft: "19px" };
    }
    if (treeDiameter <= 0.4) {
      return { width: `${treeDiameter * 23}px`, marginLeft: "20px" };
    }
    if (treeDiameter <= 0.5) {
      return { width: `${treeDiameter * 45}px`, marginLeft: "74px" };
    }
    if (treeDiameter <= 0.6) {
      return { width: `${treeDiameter * 40}px`, marginLeft: "80px" };
    }
    if (treeDiameter <= 0.7) {
      return { width: `${treeDiameter * 36}px`, marginLeft: "88px" };
    }
    if (treeDiameter <= 0.8) {
      return { width: `${treeDiameter * 32}px`, marginLeft: "93px" };
    }
    if (treeDiameter <= 0.9) {
      return { width: `${treeDiameter * 32}px`, marginLeft: "100px" };
    }
    if (treeDiameter <= 1.0) {
      return { width: `${treeDiameter * 16}px`, marginLeft: "21px" };
    }
    if (treeDiameter <= 1.1) {
      return { width: `16px`, marginLeft: "21px" };
    }
    if (treeDiameter <= 1.2) {
      return { width: `16px`, marginLeft: "21px" };
    }
    if (treeDiameter <= 1.3) {
      return { width: `16px`, marginLeft: "21px" };
    }
    if (treeDiameter <= 1.4) {
      return { width: `16px`, marginLeft: "21px" };
    }
    if (treeDiameter <= 1.5) {
      return { width: `16px`, marginLeft: "21px" };
    }
  }, [treeDiameter]);

  const treeMarginLeft = useMemo(() => {
    if (treeDiameter <= 0.4) {
      return "";
    }
    if (treeDiameter <= 0.5) {
      return "mr-[-45px]";
    }
    if (treeDiameter <= 0.6) {
      return "mr-[-50px]";
    }
    if (treeDiameter <= 0.7) {
      return "mr-[-58px]";
    }
    if (treeDiameter <= 0.8) {
      return "mr-[-63px]";
    }
    if (treeDiameter <= 0.9) {
      return "mr-[-70px]";
    }
    if (treeDiameter <= 1.0) {
      return "mr-[27px]";
    }
    if (treeDiameter <= 1.1) {
      return "mr-[27px]";
    }
    if (treeDiameter <= 1.2) {
      return "mr-[27px]";
    }
    if (treeDiameter <= 1.3) {
      return "mr-[27px]";
    }
    if (treeDiameter <= 1.4) {
      return "mr-[27px]";
    }
    if (treeDiameter <= 1.5) {
      return "mr-[27px]";
    }
    if (treeDiameter > 1.0) {
      return "";
    }
  }, [treeDiameter]);

  const treeSize = useMemo(() => {
    if (treeDiameter <= 0.1) {
      return 165;
    }
    if (treeDiameter <= 0.2) {
      return 195;
    }
    if (treeDiameter <= 0.3) {
      return 225;
    }
    if (treeDiameter <= 0.4) {
      return 255;
    }
    if (treeDiameter <= 0.5) {
      return 285;
    }
    if (treeDiameter <= 0.6) {
      return 315;
    }
    if (treeDiameter <= 0.7) {
      return 345;
    }
    if (treeDiameter <= 0.8) {
      return 375;
    }
    if (treeDiameter <= 0.9) {
      return 405;
    }
    if (treeDiameter <= 1.0) {
      return 410;
    }
    if (treeDiameter <= 1.1) {
      return 415;
    }
    if (treeDiameter <= 1.2) {
      return 420;
    }
    if (treeDiameter <= 1.3) {
      return 425;
    }
    if (treeDiameter <= 1.4) {
      return 430;
    }
    if (treeDiameter <= 1.5) {
      return 435;
    }
  }, [treeDiameter]);

  const treeDistanceStyles = useMemo(() => {
    return {
      marginLeft: treeDistance ? `${treeDistance * 40}px` : 0,
    };
  }, [treeDistance]);

  return (
    <div className="relative z-0 flex h-[300px] w-full flex-col overflow-hidden">
      <Background className="w-full grow" />

      <div className="ml-15 absolute bottom-0 left-0 right-0 top-0 z-10 flex items-end justify-start">
        <div className="grow-[2]" />
        <Person className="mb-6" style={{ transform: "scale(1.1, 1.1)" }} />
        <div className="grow-[8]" />
      </div>

      <div
        className="relative bottom-0 left-0 right-0 top-0 z-10 flex flex-col items-center"
        style={treeDistanceStyles}
      >
        {treeDiameter <= 0.4 && (
          <TreeSmall
            className={`absolute bottom-[19px] ${treeMarginLeft}`}
            style={{
              width: `${treeSize}px`,
              height: `${treeSize}px`,
            }}
          />
        )}
        {treeDiameter > 0.4 && treeDiameter <= 0.9 && (
          <TreeMedium
            className={`absolute bottom-[19px] ${treeMarginLeft}`}
            style={{
              width: `${treeSize}px`,
              height: `${treeSize}px`,
            }}
          />
        )}
        {treeDiameter > 0.9 && (
          <TreeLarge
            className={`absolute bottom-[19px] ${treeMarginLeft}`}
            style={{
              width: `${treeSize}px`,
              height: `${treeSize}px`,
            }}
          />
        )}
      </div>

      <div
        className="relative bottom-0 left-0 right-0 top-0 z-50 flex flex-col items-center justify-center"
        style={treeDistanceStyles}
      >
        <div
          className="absolute bottom-[64px] flex items-center"
          style={lineStylesLeft}
        >
          <div className="bg-textPrimary h-2 w-[1px]" />
          <div className="border-textPrimary h-[1px] flex-grow border-t border-dashed" />
          <div className="bg-textPrimary h-2 w-[1px]" />
        </div>

        <div
          className="absolute bottom-[64px] flex items-center"
          style={lineStylesMiddle}
        >
          <div className="bg-textPrimary h-2 w-[1px]" />
          <div className="border-textPrimary h-[1px] flex-grow border-t border-dashed" />
          <div className="bg-textPrimary h-2 w-[1px]" />
        </div>

        <div
          className="absolute bottom-[64px] flex items-center"
          style={lineStylesRight}
        >
          <div className="bg-textPrimary h-2 w-[1px]" />
          <div className="border-textPrimary h-[1px] flex-grow border-t border-dashed" />
          <div className="bg-textPrimary h-2 w-[1px]" />
        </div>

        <div className="absolute bottom-[56px] flex flex-col items-center gap-2">
          <div className="relative flex h-[1px] w-[1px] justify-center">
            <p className="bg-interfaceWhite text-textPrimary text-bodymd absolute rounded px-1">
              {label}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
